var _defs, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldZakaut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gold",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 27.313,
    viewBox: "0 0 36 27.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: -0.247,
    x2: 2.617,
    y2: 2.341,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b57e10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e5c35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff3a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b57e10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.235,
    y1: 1.594,
    x2: -0.8,
    y2: -0.186,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b57e10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e5c35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b57e10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2.309,
    y1: 0.609,
    x2: -0.863,
    y2: 1.284,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b57e10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e5c35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff3a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b57e10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.025,
    y1: 1.508,
    x2: 1.356,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b57e10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e5c35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff3a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b57e10"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Shape",
    x: 0,
    y: 13.216,
    width: 36,
    height: 14.097,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M12.367,21.493l-.1,0h-.094c-2.563.183-6.118-2.032-9.138-5.6C-.813,11.346.093,4.312.093,4.312A19.631,19.631,0,0,1,7.837,6.559,19.381,19.381,0,0,1,12.27,0a19.342,19.342,0,0,1,4.44,6.559,19.629,19.629,0,0,1,7.744-2.246s.906,7.034-2.946,11.582c-2.9,3.43-6.3,5.61-8.841,5.609Q12.515,21.5,12.367,21.493Z",
    transform: "translate(5.727)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape-2",
    "data-name": "Combined Shape",
    d: "M5.257,14.924q-.078.006-.157.009C2.024,14.776,0,10.03,0,4.194A11.765,11.765,0,0,1,.826,0,11.934,11.934,0,0,1,4.082,2.631q.632.746,1.178,1.5.545-.756,1.178-1.5A11.934,11.934,0,0,1,9.693,0a11.743,11.743,0,0,1,.826,4.194c0,5.836-2.024,10.581-5.105,10.738Q5.335,14.93,5.257,14.924Z",
    transform: "translate(12.74 6.55)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M2.93,15.405.726,9.614C-.826,7.635.2,3.789,2.93,0c2.732,3.789,3.761,7.635,2.2,9.614Z",
    transform: "translate(15.067 10.688)",
    fill: "url(#linear-gradient-3)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Shape)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M24.193,2.847C28.213.07,32.8-.667,36,.6A22.518,22.518,0,0,0,25.571,4.8a22.656,22.656,0,0,0-7.557,8.276l-.005.017C17.89,9.656,20.173,5.625,24.193,2.847Zm-6.2,10.232A22.706,22.706,0,0,0,10.435,4.8,22.511,22.511,0,0,0,0,.6C3.21-.667,7.787.07,11.807,2.847s6.3,6.809,6.185,10.25Z",
    transform: "translate(0 13.22)",
    fill: "url(#linear-gradient-4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldZakaut);
export default __webpack_public_path__ + "static/media/goldZakaut.24342e559ce3e8309cbeee68dc179782.svg";
export { ForwardRef as ReactComponent };